// DSL Jamaica Website Configuration
// Update this file with your contact information when available

export const siteConfig = {
  // Company Information
  companyName: "DSL Jamaica",
  tagline: "Professional Cleaning Services",
  domain: "dsljm.com",
  
  // Contact Information
  contact: {
    phone: "876-799-2106", // Your phone number
    whatsapp: "8767992106", // Your WhatsApp number (format: 876XXXXXXXXX)
    email: "info@dsljm.com", // Your email
    address: "Kingston, Jamaica", // Your full address
    addressLine2: "Serving all of Jamaica" // Additional location info
  },
  
  // Social Media - ADD WHEN AVAILABLE
  social: {
    facebook: "", // Add your Facebook page URL
    instagram: "", // Add your Instagram URL
    twitter: "" // Add your Twitter URL
  },
  
  // Business Hours
  businessHours: {
    weekdays: "Monday - Friday: 8:30 AM - 5:30 PM",
    weekend: "Saturday: 8:30 AM - 5:30 PM",
    sunday: "Sunday: Closed (Emergency services available)"
  }
};
